import { Appointment, Dossier } from '@sc/data-access-models';
import { Dayjs } from 'dayjs';
import { forEach, groupBy, sortBy } from 'lodash-es';
import { dayjs } from '../date-time';

export function groupByDateAndSort(
  dossiers: Dossier[]
): Map<string, Dossier[]> {
  const result: Map<string, Dossier[]> = new Map();

  const map = groupByDate(dossiers);

  const dossiersGroupedByDateKeys = getDossiersKeysSortedByDate(map);

  dossiersGroupedByDateKeys.forEach((key) => {
    const dateAppointments = map.get(key);
    result.set(key, dateAppointments);
  });

  return result;
}

export function groupByDate(dossiers: Dossier[]): Map<string, Dossier[]> {
  const result: Map<string, Dossier[]> = new Map();

  const groupedDossiers = groupBy(dossiers, (dossier) => {
    const appointmentDate = new Date(dossier?.appointment.time);
    return dayjs()
      .year(appointmentDate.getFullYear())
      .month(appointmentDate.getMonth())
      .date(appointmentDate.getDate())
      .format('YYYY-MM-DD');
  });

  forEach(groupedDossiers, (value, key) => {
    result.set(key, value);
  });

  return result;
}

export function getDossiersKeysSortedByDate(
  dossiers: Map<string, Dossier[]>
): string[] {
  return sortBy(Array.from(dossiers.keys()), (key) => {
    return new Date(key.toString());
  });
}

export function getPeriodReplacementVehicleUse(
  dossier: Dossier,
  defaultPeriod?: { start: string | Date; end: string | Date }
) {
  const defaultMomentStart = defaultPeriod?.start
    ? dayjs(defaultPeriod.start)
    : null;
  const defaultMomentEnd = defaultPeriod?.end ? dayjs(defaultPeriod.end) : null;

  const momentPeriodUsed: { start: Dayjs; end: Dayjs } = {
    start: null,
    end: null,
  };

  if (dossier?.appointment?.assignedReplacementVehicleUse?.start) {
    momentPeriodUsed.start = dayjs(
      dossier?.appointment?.assignedReplacementVehicleUse?.start
    );
  } else if (dossier?.appointment?.time) {
    momentPeriodUsed.start = dayjs(dossier?.appointment?.time);
  }

  if (dossier?.appointment?.assignedReplacementVehicleUse?.end) {
    momentPeriodUsed.end = dayjs(
      dossier?.appointment?.assignedReplacementVehicleUse?.end
    );
  } else if (dossier?.appointment?.endTime) {
    momentPeriodUsed.end = dayjs(dossier?.appointment?.endTime);
  } else if (
    dossier?.appointment?.time &&
    dossier?.appointment?.interventionDuration
  ) {
    momentPeriodUsed.end = dayjs(dossier?.appointment?.time).add(
      dossier?.appointment?.interventionDuration,
      'minutes'
    );
  }

  if (!momentPeriodUsed.start || !momentPeriodUsed.start.isValid()) {
    momentPeriodUsed.start = defaultMomentStart;
  }
  if (!momentPeriodUsed.end || !momentPeriodUsed.end.isValid()) {
    momentPeriodUsed.end = defaultMomentEnd;
  }
  if (
    momentPeriodUsed.start?.isSameOrAfter(momentPeriodUsed.end) &&
    !!defaultPeriod?.start &&
    !!defaultPeriod?.end
  ) {
    momentPeriodUsed.start = defaultMomentStart;
    momentPeriodUsed.end = defaultMomentEnd;
  }

  const periodUsed: Appointment['assignedReplacementVehicleUse'] = {
    start: momentPeriodUsed.start?.format(),
    end: momentPeriodUsed.end?.format(),
  };

  return periodUsed;
}
